export const AUTH_EVENTS = {
  OPEN: 'c7:auth:open',
  CHANGED: 'c7:auth:changed',
}

export function openAuthModal(mode) {
  window.dispatchEvent(new CustomEvent(AUTH_EVENTS.OPEN, { detail: { mode } }))
}

export function emitAuthChanged({ user, session_id, credit }) {
  window.dispatchEvent(new CustomEvent(AUTH_EVENTS.CHANGED, { detail: { user, session_id, credit } }))
}

